<template>
    <div id="app">
        <transition tag="div" mode="out-in" name="fade">
            <div key="loading" v-if="loading" id="loading" class="cssload-dots">
                <div class="cssload-dot"></div>
                <div class="cssload-dot"></div>
                <div class="cssload-dot"></div>
                <div class="cssload-dot"></div>
                <div class="cssload-dot"></div>
            </div>
            <div key="content" v-else id="content">
                <router-view/>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import User from "./classes/User";

export default {
    components: {},
    data() {
        return {
            user: new User(),
            loading: true,
        };
    },
    async created() {
        await this.checkTokenAndLogin();
        this.loading = false;
    },
    methods: {
        ...mapActions("user", {
            checkUserTokenAndLogin: "checkTokenAndLogin",
            logOutUser: "logout",
        }),
        async checkTokenAndLogin() {
            try {
                await this.checkUserTokenAndLogin();
            } catch (err) {
                if (this.$route.name !== "login") {
                    await this.logOutUser();
                }
                this.$displayError(err);
            }
        },
    },
};
</script>

<style lang="scss">
    html {
        height: 100%;
    }

    body {
        height: 100%;
        padding-bottom: 0 !important;
    }
    #app {
        height: 100%;
        #content {
            height: 100% !important;
        }

    }

    .checkbox {
        label {
            cursor: pointer;
        }
        span {
            cursor: pointer;
        }
    }

    .form-check {
        label {
            cursor: pointer;
        }
    }

</style>